import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Button } from "react-bootstrap";
import ReactToPrint, { PrintContextConsumer } from "react-to-print";
import TerminalAssessmentRankingForm from "../../components/TerminalAssessmentRankingForm/TerminalAssessmentRankingForm";
import TerminalAssessmentRankingTable from "../../components/TerminalAssessmentRankingTable/TerminalAssessmentRankingTable";
import TerminalAssessmentRankingHeader from "../../components/TerminalAssessmentRankingHeader/TerminalAssessmentRankingHeader";
import GradeSummary from "../../components/GradeSummary";
import { clearTerminalAssessmentRanking } from "../../actions/TerminalAssessmentRanking.action";
import { getGradeList } from "../../actions/Grade.action";
import Layout from "../../components/shared/Layout/Layout";
import { useRef } from "react";

const TerminalAssessmentRankingPage = ({
  terminalAssessmentRanking,
  clearTerminalAssessmentRanking,
  getGradeList,
  grades,
}) => {
  const ref = useRef(null);

  useEffect(() => {
    getGradeList();
  }, [getGradeList]);

  const handleClearData = () => {
    clearTerminalAssessmentRanking();
  };

  return (
    <div className="bg_light">
      <Layout title="Terminal Assessment Ranking">
        <TerminalAssessmentRankingForm grades={grades} />

        {terminalAssessmentRanking.ranking &&
          terminalAssessmentRanking.ranking.success && (
            <div className="mt-4">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 style={{ fontSize: "1.2rem" }}>
                  Ranking Results ({terminalAssessmentRanking.ranking.count}{" "}
                  students)
                </h5>
                <div className="d-flex gap-2">
                  <ReactToPrint
                    documentTitle={`Terminal Assessment Ranking - ${
                      terminalAssessmentRanking.ranking.extra?.gradeId
                        ? grades?.find(
                            (g) =>
                              g.id ===
                              terminalAssessmentRanking.ranking.extra.gradeId
                          )?.name
                        : "All Classes"
                    } - ${
                      terminalAssessmentRanking.ranking.extra?.year
                    } - Term ${terminalAssessmentRanking.ranking.extra?.term}`}
                    content={() => ref.current}
                  >
                    <PrintContextConsumer>
                      {({ handlePrint }) => (
                        <Button
                          onClick={handlePrint}
                          variant="primary"
                          size="sm"
                          className="btn_primary"
                        >
                          Print
                        </Button>
                      )}
                    </PrintContextConsumer>
                  </ReactToPrint>
                  <button
                    className="btn btn-outline-secondary btn-sm"
                    onClick={handleClearData}
                    style={{ fontSize: "0.8rem" }}
                  >
                    Clear Results
                  </button>
                </div>
              </div>

              <div ref={ref}>
                {/* Assessment Header */}
                <TerminalAssessmentRankingHeader
                  data={terminalAssessmentRanking.ranking}
                  grades={grades}
                />

                <TerminalAssessmentRankingTable
                  data={terminalAssessmentRanking.ranking.data}
                />

                {/* Grade Summary */}
                <GradeSummary
                  data={terminalAssessmentRanking.ranking.data}
                  title="Summary"
                />
              </div>
            </div>
          )}

        {terminalAssessmentRanking.loading && (
          <div className="text-center py-4">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-2">Loading ranking data...</p>
          </div>
        )}
      </Layout>
    </div>
  );
};

const mapStateToProps = (state) => ({
  terminalAssessmentRanking: state.terminalAssessmentRanking,
  grades: state.grade.grade,
});

const mapDispatchToProps = {
  clearTerminalAssessmentRanking,
  getGradeList,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TerminalAssessmentRankingPage);
